import Vue from 'vue';
import Vuex from 'vuex';
import Parts from './src/search/Parts.vue';
import { BlueSearch, store } from './src/blue-search/blue-search.js';

import '@bluemodus/blue-search/dist/style.css';

if (document.readyState === 'loading')
  window.addEventListener('DOMContentLoaded', setup);
else 
  setup();

function setup() {
  const parts = document.querySelector('#searchParts');
  const optionsParts = { ...parts.dataset };

  Vue.config.productionTip = false;
  Vue.config.devtools = false;

  Vue.use(Vuex);
  Vue.use(BlueSearch, optionsParts);

  new Vue({
    store: new Vuex.Store(store),
    render: h => h(Parts),
  }).$mount(parts);
}